module.exports = __webpack_public_path__ + "static/media/Tailored Region GIF.d95603e2.gif";